import React from 'react'
import states from 'us-state-codes'

import Horizontal from '../layouts/Horizontal.jsx'
import Card from '../components/Card.jsx'
import Grid from '../components/Grid.jsx'
import Text from '../components/Text.jsx'
import USStateMap from '../components/USStateMap.jsx'
import usePosition from '../hooks/usePosition.js'
import useRect from '../hooks/useRect.js'

import useRequest from '../hooks/useRequest.js'
import { getStatesOverindex } from '_services/insights-v2.js'

const StateCard = ({ state }) => {
  const [Rect, rect] = useRect()
  const [labelRef, labelRect] = usePosition()

  return (
    <Card showBorder={true}>
      <Rect />
      {rect.width && (
        <USStateMap
          state={state.stateCode}
          width={rect.width}
          height={rect.height / 2 - 32}
          x={0}
          y={0}
        />
      )}
      <Text
        gRef={labelRef}
        value={states.getStateNameByStateCode(state.stateCode)}
        x={0}
        y={rect.height / 2}
        width={rect.width}
        textAnchor="middle"
        fontSize={28}
        fill="#3D3D3D"
      />
      <Text
        value={`${state.value.toFixed(2)}x`}
        x={0}
        y={rect.height / 2 + labelRect.height + 12}
        width={rect.width}
        textAnchor="middle"
        fontSize={50}
        fontWeight="bold"
        fill="#13682B"
      />
    </Card>
  )
}

const NotUSA = () => {
  const [CardRect, cardRect] = useRect()

  return (
    <>
      <CardRect />
      <Grid
        direction="horizontal"
        gap={0}
        items={[
          {
            component: (
              <Text
                value="This report doesn't have U.S. states"
                x={0}
                y={cardRect.height / 2}
                width={cardRect.width}
                textAnchor="middle"
                fontSize={50}
                fontWeight="bold"
                fill="#13682B"
              />
            ),
            size: 1,
          },
        ]}
      />
    </>
  )
}

const format = (data) => {
  const allStates = Object.entries(data ?? {}).map(([key, value]) => ({
    stateCode: key,
    value: Number(value),
  }))
  allStates.sort((a, b) => (a.value < b.value ? 1 : -1))

  const topStates = allStates.slice(0, 5)

  return topStates
}

const isNotUSA = (regions = []) => !regions.find((region) => region.countries.includes('US'))

const TopIndexingStates = (props) => {
  const {
    audience: { _id: audienceId },
  } = props
  const { title, description, section_1 } = props.data

  const { data } = useRequest(getStatesOverindex, { audienceId }, true)

  const topStates = format(data)

  const renderStateCard = (state) => ({
    component: <StateCard state={state} />,
    size: 1 / 3,
  })

  return (
    <Horizontal
      title={title}
      description={description}
      page={props.index + 1}
      notes={section_1.footnote}
      content={() => (
        <Card title={section_1.title} description={section_1.subtitle} showBorder={false}>
          {isNotUSA(props?.audience?.regions) ? (
            <NotUSA />
          ) : (
            <Grid
              direction="vertical"
              gap={40}
              items={[
                {
                  component: (
                    <Grid
                      direction="horizontal"
                      gap={40}
                      items={topStates.slice(0, 3).map(renderStateCard)}
                    />
                  ),
                  size: 0.5,
                },
                {
                  component: (
                    <Grid
                      direction="horizontal"
                      gap={40}
                      items={topStates.slice(3, 5).map(renderStateCard)}
                    />
                  ),
                  size: 0.5,
                },
              ]}
            />
          )}
        </Card>
      )}
    />
  )
}

export default TopIndexingStates
